export const toFormatedNumber = (number: string | number): string => {
  if (typeof number === 'number') {
    return number.toLocaleString()
  } else {
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }
}
export const toUnformatedNumber = (number: string, precision?: number): string => {
  const result = number.replace(/[^\d-,.]/g, '').replace(/,/g, '.').replace(/\.(?=.*\.)/g, '')

  const [int, decimal] = result.split('.')

  if (decimal === undefined) return int

  if (precision === undefined) {
    return `${int}.${decimal}`
  }

  return `${int}.${decimal.slice(0, precision)}`
}
